import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=16bab13e&scoped=true&"
import script from "./roleEdit.vue?vue&type=script&lang=js&"
export * from "./roleEdit.vue?vue&type=script&lang=js&"
import style0 from "./roleEdit.vue?vue&type=style&index=0&id=16bab13e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bab13e",
  null
  
)

export default component.exports